import api from 'api'
import { queryParamSerializer } from 'lib/api/queryParamSerializer'
import type { FieldglassOperationIssueType } from 'pages/Fieldglass/shared/constants/issueTypes'

export type FieldglassOperationIssue = {
  id: number
  issueType: FieldglassOperationIssueType
  issueTypeLabel: string
  message: string
  workerId: number | null
  workerName: string | null
}

export type FieldglassShiftIssuesItem = {
  shiftId: number
  companyGroupId: number
  companyGroupName: string | null
  positionName: string | null
  jobPostingId: string | null
  issues: FieldglassOperationIssue[]
}

export type FieldglassShiftIssuesItems = FieldglassShiftIssuesItem[]

export type ListFieldglassShiftIssuesRequest = {
  page: number
  pageSize: number
  daysAgo?: number | null
  companyGroupIds?: number[] | null
  issueTypes?: FieldglassOperationIssueType[] | null
}

export type ListFieldglassShiftIssuesResponse = {
  items: FieldglassShiftIssuesItems
  totalRows: number
  totalPages: number
  currentPage: number
  pageSize: number
}

export const listFieldglassShiftIssues = async (
  request: ListFieldglassShiftIssuesRequest
): Promise<ListFieldglassShiftIssuesResponse> => {
  const params = {
    page: request.page,
    page_size: request.pageSize,
    days_ago: request.daysAgo,
    company_group_ids: request.companyGroupIds,
    issue_types: request.issueTypes,
  }

  const response = await api.get<ListFieldglassShiftIssuesResponse>(
    '/admin/fieldglass/shift_issues',
    { params, paramsSerializer: queryParamSerializer }
  )
  return response.data
}
